import { useEffect, useRef, useState } from 'react';
import {Link, useNavigate, useSearchParams} from 'react-router-dom';

import AddIconWhite from '../../assets/icons/iconAddWhite.svg';
import './style.scss';
import UserAttendanceCard from '../../components/userAttendanceCard';
import {
  getBeneficiaries,
  getMeetingsAttendance,
  saveMeetingAttendance
} from '../../API/apiService';
import { toast } from 'react-toastify';
import { useLoader } from '../../contexts/loader/loader';

function SingleMeeting() {
  const { show } = useLoader();
  const navigate = useNavigate();
  // STATES //
  const [searchParams] = useSearchParams();
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [info, setInfo] = useState({
    goal: '',
    groupId: '',
    meetingId: '',
    meetingNotes: '',
    meetingDate: '',
    meetingType: '',
    meetingTypeName: '',
    images: [],
    beneficiaries: [],
    order: '',
    edit: false
  });
  const [beneficiaries, setBeneficiaries] = useState([]);

  const inputRefs = useRef([]);
  const setInputRef = (index, ref) => {
    inputRefs.current[index] = ref;
  };

  const [attendanceImages, setAttendanceImages] = useState([
    {
      imageUrl: '',
      id: 0,
      updated: false,
      base64: null,
      externalId: null,
      savedInDB: false
    },
    {
      imageUrl: '',
      id: 1,
      updated: false,
      base64: null,
      externalId: null,
      savedInDB: false
    },
    {
      imageUrl: '',
      id: 2,
      updated: false,
      base64: null,
      externalId: null,
      savedInDB: false
    }
  ]);

  const baseURL = process.env.REACT_APP_API_URL + process.env.REACT_APP_API_URI;

  function handleImageClick(index, saved) {
    if (saved === true) {
      toast('No puedes modificar las evidencias', {
        type: 'info'
      });
      return;
    }
    // Trigger the input click event
    if (inputRefs.current[index]) {
      inputRefs.current[index].click();
    }
  }

  function handleCaptureImage(target, identifier, saved) {
    if (saved === true) {
      toast('No puedes modificar las evidencias', {
        type: 'info'
      });
      return;
    }
    if (target.files) {
      if (target.files.length > 0) {
        const file = target.files[0];
        const newUrl = URL.createObjectURL(file);
        const updatedImageList = [...attendanceImages];

        const reader = new FileReader();
        reader.readAsDataURL(file);

        const img = updatedImageList.find(a => a.id === identifier);
        reader.onload = () => {
          const image = new Image();
          image.src = reader.result;

          image.onload = () => {
            const canvas = document.createElement('canvas');
            const maxWidth = 800; // Set your desired maximum width here
            const maxHeight = 600; // Set your desired maximum height here
            let width = image.width;
            let height = image.height;

            if (width > height) {
              if (width > maxWidth) {
                height *= maxWidth / width;
                width = maxWidth;
              }
            } else {
              if (height > maxHeight) {
                width *= maxHeight / height;
                height = maxHeight;
              }
            }

            canvas.width = width;
            canvas.height = height;

            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, width, height);

            const resizedImageBase64 = canvas.toDataURL('image/jpeg');
            // console.log(resizedImageBase64);

            // Send the resized image to an API

            // Perform further processing with the imageBase64 data if needed
            img.base64 = resizedImageBase64;
          };
          /* const imageBase64 = reader.result;
                          console.log(imageBase64);
                          // Perform further processing with the imageBase64 data if needed
                          img.base64 = imageBase64; */
        };
        if (img) {
          img.imageUrl = newUrl;
          img.updated = true;
        }
        setAttendanceImages(updatedImageList);
      }
    }
  }

  function addInfo(id, personalId, selectedValue) {
    if (personalId === 'meetingNotes' || personalId === 'goal') {
      if (id?.length > 255) {
        id = id.substring(0, 255);
      }
    }
    if (selectedValue) {
      const valueName = `${personalId}Value`;
      setInfo({ ...info, [personalId]: id, [valueName]: selectedValue });
    } else {
      setInfo({ ...info, [personalId]: id });
    }
  }

  /*  function clear() {
         setAttendanceImages([{imageUrl: '', id: 0, updated: false, base64: null, externalId: null},
             {imageUrl: '', id: 1, updated: false, base64: null, externalId: null},
             {imageUrl: '', id: 2, updated: false, base64: null, externalId: null}])
     } */

  async function saveMeeting() {
    if (!info.goal) {
      toast('Debe definir un objetivo', {
        type: 'warning'
      });
      return;
    }
    if (
      beneficiaries.find(a => a.attended === null || a.attended === undefined)
    ) {
      toast('Debe tomar la asistencia de todos los beneficiarios', {
        type: 'warning'
      });
      return;
    }
    const notUpdated = attendanceImages.filter(a => !a.updated);
    if (notUpdated && notUpdated.length > 2) {
      toast('Debe subir mínimo 1 registros fotográfico', {
        type: 'warning'
      });
      return;
    }
    if (!info.meetingType) {
      toast('Debe Seleccionar un tipo de reunion', {
        type: 'warning'
      });
      return;
    }
    if (!info.meetingDate) {
      toast('Seleccione una fecha', {
        type: 'warning'
      });
      return;
    }
    setButtonDisabled(true);
    await show(true);
    info.beneficiaries = beneficiaries;
    info.images = attendanceImages.filter(i => i.base64);

    info.meetingType = 'PRE';
    info.meetingTypeName = 'Presencial';
    info.meetingTypeValue = 'Presencial';

    const response = await saveMeetingAttendance(info);
    await show(false);
    setButtonDisabled(false);
    if (response) {
      toast('Asistencia Guardada Satisfactoriamente', {
        type: 'success'
      });
      navigate('/escuelas/grupo/lista_de_encuentros',{
          state: { group: info.groupId }
    });
    }
  }

  async function getInfo(meetingId) {
    info.meetingId = meetingId;
    const list = await getBeneficiaries(null, meetingId);

    const meetingInfo = await getMeetingsAttendance(meetingId);
    if (meetingInfo) {
      const imgs = meetingInfo.meetingImages.map(a => {
        return {
          imageUrl: `${baseURL}/image?imageId=${
            a.id
          }&thumbnail=${!!a.thumbnail}`,
          id: a.id,
          updated: true,
          base64: null,
          externalId: a.id,
          savedInDB: true
        };
      });

      // this beacause time is in utc and anotheer time in utc -5
      if (meetingInfo.meeting.meeting_date) {
        const idx = meetingInfo.meeting.meeting_date.indexOf('T');
        if (idx > 0) {
          info.meetingDate = meetingInfo.meeting.meeting_date.substring(0, idx);
        } else {
          info.meetingDate = meetingInfo.meeting.meeting_date;
        }
      }
      info.groupId = meetingInfo.meeting.group_id;
      info.goal = meetingInfo.meeting.goal;
      info.meetingNotes = meetingInfo.meeting.notes;
      info.meetingType = 'PRE';
      info.meetingTypeName = 'Presencial';
      info.meetingTypeValue = 'Presencial';
      info.edit = !!(meetingInfo.meeting.meeting_date && info.goal);

      if (imgs && imgs.length > 0) {
        const imgsSaved = imgs.length;
        if (imgsSaved < 3) {
          for (let i = imgsSaved; i < 3; i++) {
            imgs.push({
              imageUrl: '',
              id: i,
              updated: false,
              base64: null,
              externalId: null,
              savedInDB: false
            });
          }
        }
        setAttendanceImages(imgs);
      }
      if (meetingInfo?.attendances && meetingInfo?.attendances.length > 0) {
        const beneficiariesList = list.map(b => {
          const benInfo = meetingInfo.attendances.find(
            a => a.beneficiary_id === b.id
          );
          const beneficiaryData = {
            id: b.id,
            full_name: b.full_name,
            document: b.document
          };
          if (benInfo) {
            beneficiaryData.savedInMeeting = true;
            beneficiaryData.attended = benInfo.attended;
            beneficiaryData.argument = benInfo.argument;
            beneficiaryData.notes = benInfo.notes;
            if (beneficiaryData.attended === true && benInfo.image) {
              beneficiaryData.imageId = benInfo.image.id;
              beneficiaryData.thumbnail = benInfo.image.thumbnail;
            }
          }
          return beneficiaryData;
        });
        setBeneficiaries(beneficiariesList);
      } else {
        if (list) {
          setBeneficiaries(
            list.map(b => {
              return {
                id: b.id,
                full_name: b.full_name,
                document: b.document,
                savedInMeeting: false
              };
            })
          );
        }
      }
    }
  }

  useEffect(() => {
    const entries = Object.fromEntries(searchParams);
    getInfo(entries?.encuentro);
  }, []);

  return (
    <section className='singleMetting-main-container'>
      <div  className='bread-crumbs'>
        / <Link  to={'/escuelas/grupo/lista_de_encuentros'}
                 state={{ group:  info.groupId  }}> lista_de_encuentros</Link>
      </div>
      <div className='principal-container'>
        <div className='title-container'>
          <h1 className='title'></h1>
          <p className='description'>Lista de asistencia</p>
        </div>
        <div className='inputs-container'>

          <label className='input-date-container' htmlFor=''>
            {info.edit && <p>{info.meetingDate}</p>}
            {!info.edit && (
              <input
                type='date'
                onChange={e => addInfo(e.target.value, 'meetingDate')}
                className='input-form'
                value={info.meetingDate}
              />
            )}
          </label>
          <label className='input-area-container' htmlFor=''>
            <textarea
              type='topic'
              placeholder='Objetivo'
              onChange={e => addInfo(e.target.value, 'goal')}
              className='input-form'
              value={info.goal}
              max={250}
            />
          </label>
          <label className='input-area-container' htmlFor=''>
            <textarea
              type='topic'
              placeholder='Observaciones'
              onChange={e => addInfo(e.target.value, 'meetingNotes')}
              className='area'
              value={info.meetingNotes}
              max={255}
            />
          </label>
        </div>
        <div className='photos-register-container'>
          <p className='title'>Registro fotográfico</p>
          <div className='assistence-photos'>
            {attendanceImages.map((imgInfo, index) => (
              <div key={index}>
                {imgInfo.updated ? (
                  <img
                    key={index}
                    className='photo'
                    src={imgInfo.imageUrl}
                    alt={`Image ${index}`}
                    onClick={() => handleImageClick(index, imgInfo.savedInDB)}
                  />
                ) : (
                  <img
                    key={index}
                    className='iconWhite'
                    src={AddIconWhite}
                    alt={`Image ${index}`}
                    onClick={() => handleImageClick(index, imgInfo.savedInDB)}
                  />
                )}
                <input
                  accept='image/*'
                  id={`icon-button-file${index}`}
                  key={`button-file${index}`}
                  type='file'
                  ref={ref => setInputRef(index, ref)}
                  capture='environment'
                  onChange={e =>
                    handleCaptureImage(e.target, index, imgInfo.savedInDB)
                  }
                  style={{ display: 'none' }}
                />
              </div>
            ))}
          </div>
        </div>
        <p className='total-beneficiaries'>
          Total de beneficiarios inscritos: <span>{beneficiaries?.length}</span>
        </p>
        <div className='beneficiaries-list'>
          {beneficiaries &&
            beneficiaries?.length > 0 &&
            beneficiaries.map((beneficiary, i) => (
              <UserAttendanceCard key={i} data={beneficiary} />
            ))}
        </div>
        <div className='save-button-container'>
          <button
            className='blue-site-button saveAll'
            onClick={saveMeeting}
            disabled={buttonDisabled}>
            GUARDAR
          </button>
        </div>
      </div>
    </section>
  );
}

export default SingleMeeting;